import { WritableSignal } from '@angular/core';

/**
 * Enum of all available feature flag keys
 */
export enum FeatureFlagKey {
  IS_DATA_SNAPSHOT_VISIBLE = 'DataSnapshots',
  IS_SCHEDULER_PAGE_VISIBLE = 'scheduler',
  // Add more feature flags here as needed - the values have to match with LD keys
}

/**
 * Type for the feature flags values
 */
export type FeatureFlagKeyType = FeatureFlagKey;
export type IFeatureFlag<T> = Record<FeatureFlagKeyType, WritableSignal<T>>;

